const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eab7614b-c823-44df-b665-e50034a67a36",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.19,10.35h-11a.7.7,0,0,1,0-1.4h11a.7.7,0,0,1,0,1.4Z",
    style: {
      fill: "#456d86"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.19,6.35h-11a.7.7,0,1,1,0-1.4h11a.7.7,0,1,1,0,1.4Z",
    style: {
      fill: "#456d86"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.19,2.35h-11a.7.7,0,0,1,0-1.4h11a.7.7,0,0,1,0,1.4Z",
    style: {
      fill: "#456d86"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.8ec7a989150c5005afbc7c83485a9b00.svg";
export { ForwardRef as ReactComponent };